export default __webpack_public_path__ + "static/media/drag_pin.351592dd.svg";